<style lang="less" scoped>
.top1 {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;
  height: 38px;
  color: #000;
  line-height: 38px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  // justify-content: space-between;
  box-sizing: border-box;
  background-image: linear-gradient(180deg, #0b3362, #1f4873);
}
.top1 img:first-child {
  height: 18px;
  width: 18px;
  vertical-align: middle;
  margin-left: 0.3125rem;
  margin-top: 10px;
  position: absolute;
  left: 0;
}
.top1 h3 {
  color: #fff;
  font-size: 13px;
  /* font-family: monospace; */
  font-weight: normal;
  font-family: sans-serif;
}
.top1 .showMenu {
  width: 25px;

  position: absolute;
  right: 0;
  margin-top: 7px;
}
</style>
<template>
  <div class="top1">
    <img
      @click="leftContent"
      src="data:image/png;base64,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"
    />
    <h3>{{ title }}</h3>
    <img class="showMenu" @click="showMneu" src="../assets/images/menu.png" />
    <div v-if="showMenu">
      <ComMenu></ComMenu>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import ComMenu from "./menu.vue";
export default {
  inject: ["reload"],
  components: {
    ComMenu,
  },
  data() {
    return {
      showMenu: false,
      i: 1,
      title: "",
      type: "",
    };
  },
  beforeCreate() {
    var link = window.location.href;

    if (link.indexOf("/en") != -1) {
      this.$cookie.set("lang", "en", {
        expires: "1h",
      });
    } else {
      this.$cookie.delete("lang");
    }
  },
  // beforeMount() {
  //   var link = window.location.href;

  //   if (link.indexOf("/en") != -1) {
  //     this.$cookie.set("lang", "en", {
  //       expires: "1h",
  //     });
  //   } else {
  //     this.$cookie.delete("lang");
  //   }
  // },
  mounted() {
    this.type = this.$getUrlParam("source");
    if (this.type == "wx") {
      $(".top1").css("display", "none");
      $(".intros").css("margin-top", "0");
      $(".contents").css("margin-top", "0");
      $(".guider").css("padding-top", "0");
    }
  },
  methods: {
    showMneu() {
      if (this.i % 2 == 1) {
        this.showMenu = true;
        this.i++;
      } else {
        this.showMenu = false;
        this.i++;
      }
    },

    leftContent() {
      this.$router.go(-1);
      this.reload();
    },
  },
};
</script>